import { Component } from '@angular/core';
import { UserService } from './api/user.service';
import {FolderPage} from './folder/folder.page';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {
  //---------------------------------------------------------------
  /*showON = false;
  temperature: any = 'NA';
  humidity: any = 'NA';
  ceiling: any = 'NA';
  precipitation: any = 'NA';
  convective: any = 'NA';
  midCloud: any = 'NA';
  lowCloud: any = 'NA';
  visibility: any = 'NA';
  windSpeed: any = 'NA';
  windDir: any = 'NA';
  windSpeed150m: any = 'NA';
  windDir150m: any = 'NA';
  data: any = 'NA';
  hour: any = 'NA';
  time: any =  'Select';*/
  //-------------------------------------------------------------------
  constructor(public folder: FolderPage, private homeService: UserService) {
    this.homeService.httpGET();
    //console.log('app.component');
    
  }

  start(val) {
    this.folder.start(val);
  }

}
